export default __webpack_public_path__ + "static/media/confetti.256ee6d5.png";